import React from 'react';
import {createRoot, Root} from 'react-dom/client';
import {BridalSetBuilderApp} from './ui/BridalSetBuilderApp';
import './styles.css';

type Money = {cents: number; formatted: string};

type GiftBoxOption = {
  title: string;
  handle: string;
  variantId: number;
  price: Money;
};

type VariantOption = {
  id: number;
  title: string;
  available: boolean;
  price: Money;
};

type ProductData = {
  id: number;
  title: string;
  handle: string;
  image?: string | null;
  url?: string | null;
  variants: VariantOption[];
  giftBoxes: GiftBoxOption[];
};

type StepData = {
  id: 1 | 2;
  title: string;
  description?: string;
  products: ProductData[];
};

type BuilderData = {
  title: string;
  description?: string;
  steps: [StepData, StepData];
};

function safeJsonParse<T>(text: string): T | null {
  try {
    return JSON.parse(text) as T;
  } catch {
    return null;
  }
}

class BridalSetBuilderElement extends HTMLElement {
  private root: Root | null = null;

  connectedCallback() {
    if (this.root) return;
    const script = this.querySelector<HTMLScriptElement>('script[type="application/json"][data-bsb]');
    const raw = script?.textContent ? safeJsonParse<BuilderData>(script.textContent) : null;

    if (!raw || !raw.steps || raw.steps.length !== 2) {
      this.innerHTML =
        '<div class="bsb bsb--error">Bridal Set Builder: missing or invalid JSON data.</div>';
      return;
    }

    this.classList.add('bsb-host');
    this.root = createRoot(this);
    this.root.render(<BridalSetBuilderApp data={raw} />);
  }

  disconnectedCallback() {
    this.root?.unmount();
    this.root = null;
  }
}

declare global {
  interface Window {
    __BSB_DEFINED__?: boolean;
  }
}

if (!window.__BSB_DEFINED__) {
  window.__BSB_DEFINED__ = true;
  customElements.define('bridal-set-builder', BridalSetBuilderElement);
}

